import React from 'react'

import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Text from '../../../../components/pdf/Text'
import Bar from '../../../../components/pdf/Bar'

const Header = () => (
  <>
    <Grid justify="space-between" align="center">
      <Col>
        <Image src="/pdfs/segurpro/segurpro.png" maxWidth={100} ignoreFixedSize />
      </Col>
      <Col>
        <Text italic bold size="small">
          SEGURPRO TECNOLOGIA EM SISTEMAS DE SEGURANÇA ELETRÔNICA E INCÊNDIO LTDA - B34-10B
        </Text>
        <Text italic size="xsmall">
          Endereço: R. Olaria, 292, Cidade Industrial Satelite De São Paulo 07223-260 Guarulhos SP
        </Text>
        <Text italic size="xsmall">
          CNPJ: 07.616.290/0006-56
        </Text>
      </Col>
    </Grid>
    <Bar />
  </>
)

export default Header
